import React from 'react';
import _ from 'lodash';

import Dropdown from 'ub/components/dropdown/dropdown';
import {urlActions} from './text-panel-defaults';

export default class UrlAction extends React.Component {
  constructor(props) {
    super(props);

    this.changeAction = this.changeAction.bind(this);

    this.selectedAction = _(urlActions)
      .filter((action) => action.value === this.props.currentAction)
      .map((action) => action.label)
      .head();
  }

  changeAction(action) {
    this.props.changeHandler({
      type: 'urlActionChange',
      value: action
    });
  }

  render() {
    return (
      <Dropdown
        className="url-action-dropdown"
        value={this.props.currentAction}
        changeHandler={this.changeAction}
        label={this.selectedAction}
        disabled={this.props.disabled}
        options={urlActions}
      />
    );
  }
}

UrlAction.propTypes = {
  disabled: React.PropTypes.bool,
  currentAction: React.PropTypes.string,
  changeHandler: React.PropTypes.func
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/style-tab-content-components/url-action.jsx